export default __webpack_public_path__ + "static/media/message.aa9e1256.svg";